import { IRuleOptions, IValidationOptions, IValidationRule, RuleName } from "./Validator";

export class RequiredRule implements IValidationRule
{
    public rule: RuleName = 'Required';
    private errorLabel: string;

    constructor(validationOptions: IValidationOptions, ruleOptions: IRuleOptions = {})
    {
        this.errorLabel = ruleOptions.errorLabel ?? validationOptions.isRequiredLabel ?? validationOptions.invalidFieldLabel;
    }

    public validate(value: string): string
    {
        if (value?.trim().length > 0)
        {
            return '';
        }
        return this.errorLabel;
    }
}
